import { useQuery } from '@tanstack/react-query'
import { useSearch } from '@tanstack/react-router'

import { dashboardTaskSearchQuery } from '@/lib/queries/business/v1/task/search/queries'

import { ACTION_ACCORDION_MENU_NAME_MAP } from '../../../constants'
import { ActionCompletedTable } from './action-completed-table/action-completed-table'

export const useActionCompletedAccordion = () => {
  const { keyword, assignees, assigneeCondition } = useSearch({
    from: '/_app/_dashboard/dashboard/_taskManagement/task-management/action-completed',
  })

  const { data: actionRequiredTaskData, isFetching: isFetchingTaskData } = useQuery(
    dashboardTaskSearchQuery({
      keyword,
      assignees: assignees?.map((v) => Number(v)),
      assigneeCondition,
      completeStatus: true,
    })
  )

  const rfeTaskData = actionRequiredTaskData?.filter(
    ({ taskType }) => taskType === ACTION_ACCORDION_MENU_NAME_MAP.rfe
  )[0]
  const interviewTaskData = actionRequiredTaskData?.filter(
    ({ taskType }) => taskType === ACTION_ACCORDION_MENU_NAME_MAP.interview
  )[0]
  const biometricTaskData = actionRequiredTaskData?.filter(
    ({ taskType }) => taskType === ACTION_ACCORDION_MENU_NAME_MAP.biometric
  )[0]
  const caseInquiryEligibleTaskData = actionRequiredTaskData?.filter(
    ({ taskType }) => taskType === ACTION_ACCORDION_MENU_NAME_MAP.caseInquiryEligible
  )[0]
  const aosEligibleTaskData = actionRequiredTaskData?.filter(
    ({ taskType }) => taskType === ACTION_ACCORDION_MENU_NAME_MAP.aosEligible
  )[0]

  const isSearchFilterApplied = !!keyword || assignees || assigneeCondition
  const expandedMenuNames = isSearchFilterApplied
    ? ([
        rfeTaskData?.count && ACTION_ACCORDION_MENU_NAME_MAP.rfe,
        interviewTaskData?.count && ACTION_ACCORDION_MENU_NAME_MAP.interview,
        biometricTaskData?.count && ACTION_ACCORDION_MENU_NAME_MAP.biometric,
        caseInquiryEligibleTaskData?.count && ACTION_ACCORDION_MENU_NAME_MAP.caseInquiryEligible,
        aosEligibleTaskData?.count && ACTION_ACCORDION_MENU_NAME_MAP.aosEligible,
      ].filter((v) => v) as string[])
    : []

  const accordionMenuData = [
    {
      title: 'RFE',
      count: rfeTaskData ? rfeTaskData.count : 0,
      content: <ActionCompletedTable data={rfeTaskData ? rfeTaskData.result : []} />,
    },
    {
      title: 'Interview',
      count: interviewTaskData ? interviewTaskData.count : 0,
      content: <ActionCompletedTable data={interviewTaskData ? interviewTaskData.result : []} />,
    },
    {
      title: 'Biometric',
      count: biometricTaskData ? biometricTaskData.count : 0,
      content: <ActionCompletedTable data={biometricTaskData ? biometricTaskData.result : []} />,
    },
    {
      title: 'Case Inquiry Eligible',
      count: caseInquiryEligibleTaskData ? caseInquiryEligibleTaskData.count : 0,
      content: <ActionCompletedTable data={caseInquiryEligibleTaskData ? caseInquiryEligibleTaskData.result : []} />,
    },
    {
      title: 'AOS Eligible',
      count: aosEligibleTaskData ? aosEligibleTaskData.count : 0,
      content: <ActionCompletedTable data={aosEligibleTaskData ? aosEligibleTaskData.result : []} />,
    },
  ]

  return {
    accordionMenuData,
    isFetchingTaskData,
    expandedMenuNames,
  }
}
